var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w-100 bg-light"},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center",staticStyle:{"color":"rgb(169, 169, 169)"},attrs:{"cols":"12"}},[_vm._v("\n        © Copyrighted Dream Come True Education Park Limited 2021\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-014effe2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/OrFooter.vue
// module id = null
// module chunks = 